import styles from './ProcessingIndicator.module.css';

interface ProcessingIndicatorProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

export function ProcessingIndicator({ size = 'md', label = 'Processing' }: ProcessingIndicatorProps) {
  const GRID_SIZE = 5;
  const SIZE_MAP = { sm: 160, md: 220, lg: 300 };
  const cellSize = SIZE_MAP[size];
  const gap = size === 'sm' ? 4 : size === 'md' ? 6 : 8;
  const dotRadius = size === 'sm' ? 2 : size === 'md' ? 3 : 4;

  return (
    <div
      className={styles.container}
      style={{ width: cellSize, height: cellSize }}
      role="status"
      aria-live="polite"
    >
      <div
        className={styles.grid}
        style={{
          width: cellSize,
          height: cellSize,
          gap: `${gap}px`,
        }}
        onMouseMove={(e) => {
          const rect = e.currentTarget.getBoundingClientRect();
          const x = ((e.clientX - rect.left) / rect.width) * 100;
          const y = ((e.clientY - rect.top) / rect.height) * 100;
          e.currentTarget.style.setProperty('--mouse-x', `${x}%`);
          e.currentTarget.style.setProperty('--mouse-y', `${y}%`);
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.setProperty('--mouse-x', '50%');
          e.currentTarget.style.setProperty('--mouse-y', '50%');
        }}
      >
        {Array.from({ length: GRID_SIZE * GRID_SIZE }, (_, i) => {
          const col = i % GRID_SIZE;
          const row = Math.floor(i / GRID_SIZE);
          const center = (GRID_SIZE - 1) / 2;
          const dist = Math.sqrt((col - center) ** 2 + (row - center) ** 2);
          const maxDist = Math.sqrt(2 * center ** 2);
          const delay = (dist / maxDist) * 2;

          return (
            <div
              key={i}
              className={styles.dot}
              style={
                size === 'sm'
                  ? { '--dot-delay': `${delay}s`, '--dot-radius': `${dotRadius}px` } as React.CSSProperties
                  : { '--dot-delay': `${delay}s`, '--dot-radius': `${dotRadius}px` } as React.CSSProperties
              }
            />
          );
        })}
      </div>
      {label && (
        <p className={styles.label}>
          {label}
          <span className={styles.dots}>
            <span className={styles.dot1}>.</span>
            <span className={styles.dot2}>.</span>
            <span className={styles.dot3}>.</span>
          </span>
        </p>
      )}
    </div>
  );
}
